import React from 'react'
import { cn } from '../../lib/utils'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  size?: 'sm' | 'md' | 'lg'
  wrapperClassName?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, wrapperClassName, size = 'md', ...props }, ref) => {
    const sizes = {
      sm: 'text-sm',
      md: '',
      lg: 'text-base',
    }

    return (
      <div className={cn('relative', wrapperClassName)}>
        <textarea
          ref={ref}
          className={cn(
            'w-full text-base leading-relaxed text-foreground/90 whitespace-pre-wrap rounded-lg border border-black/10 bg-white p-3 focus:outline-none focus:ring-2 focus:ring-brand-500',
            sizes[size],
            className,
          )}
          {...props}
        />
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'

export { Textarea }
export default Textarea